import React from 'react'
import './CountrySelection.scss'
import { Dropdown } from 'primereact/dropdown'
import { useTranslation } from 'react-i18next'

const CountrySelection = (props: {
  countries: any
  isAbroad: any
  setIsAbroad: any
  setSelectedLocation: any
  filterClear: any
}) => {
  const { t } = useTranslation()
  const handleOnChange = (event: any) => {
    props.setIsAbroad(event.value)
    props.filterClear()
    props.setSelectedLocation(undefined)
  }
  const itemTemplate = (options: any) => {
    if (options) {
      return (
        <div>
          <p>{t(options.name)}</p>
        </div>
      )
    }
  }
  const valueTemplate = (options: any) => {
    if (options) {
      return (
        <div className="selectedTxt">
          <p>{t(options.name)}</p>
        </div>
      )
    }
  }
  return (
    <div
      className={
        props.countries.length === 1
          ? 'country-selection-container container-hover'
          : 'country-selection-container star-container-hover'
      }>
      <label className="autocomplete-title">{t('input-texts.country')}</label>
      <i className="autocomplete-icon p-input-icon-left pi pi-map-marker"></i>

      <Dropdown
        className={props.countries.length === 1 ? 'country-autocomplete' : 'star-country-autocomplete'}
        optionLabel="name"
        itemTemplate={itemTemplate}
        valueTemplate={valueTemplate}
        disabled={props.countries.length === 1}
        options={props.countries}
        value={props.isAbroad}
        onChange={(e) => handleOnChange(e)}
      />
      {props.countries.length === 1 ? null : <span className="star-icon p-input-icon-right"></span>}
    </div>
  )
}

export default CountrySelection
